<template>
    <transition name="fade">
        <div class="VideoGallery" v-show="videoGalleryVisible" @click="toggleVideoGallery()">
            <div class="vg-container" @click="$event.stopPropagation()">
                
                <div class="vg-bar">
                    <p class="vg-bar-name">{{name}}</p>
                    <div class="vg-bar-buttons">  
                        <md-button class="md-icon-button" @click="toggleVideoGallery()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <video id="vg-video" class="vg-video" :src="getVideoURL"/>
                <div class="vg-controls">
                    <div class="vg-controls-top">
                        <button class="vg-controls-button" @click="skipVideo(-1)">
                            <img class="vg-controls-button-image" :src="'./flux/skip_previous.svg'" alt="">
                        </button>
                        <button class="vg-controls-button" @click="playVideo()">
                            <img class="vg-controls-button-image" :src="paused ? './flux/play.svg' : './flux/pause.svg'" alt="">
                        </button>
                        <button class="vg-controls-button" @click="skipVideo(1)">
                            <img class="vg-controls-button-image" :src="'./flux/skip_next.svg'" alt="">
                        </button>
                        <span class="vg-controls-time">{{videoCurentTime}}</span>
                    </div>
                    
                    <input value="0" id="vg-slider" class="vg-controls-slider" step="0.001" @input="changeTime()" type="range">
                </div>
            </div>
        </div>  
    </transition>
</template>

<style scoped>
    .VideoGallery{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: #000000d0;
    }
    .vg-container{
        position: absolute;
        margin-top: 30px;
        background: white;
        border-radius: 10px;
        width: 80%;
    }
    .vg-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .vg-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .vg-bar-buttons{
        margin-left: auto;
    }
    .vg-video{
        width: 100%;
        border-radius: 0px 0px 8px 8px;
    }
    .vg-controls{
        position: absolute;
        bottom: 0;
        opacity: 0;
        transition: .3s opacity ease-in-out;
        height: 70px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.788) 70%);
        border-radius: 0px 0px 9px 9px;
    }
    .vg-video:hover + .vg-controls{
        opacity: 1;
    }
    .vg-controls:hover{
        opacity: 1;
    }
    .vg-controls-button{
        border: none;
        background: transparent;
        border-radius: 5px;
        transition: .2s background ease;
        margin: 2px;
        cursor: pointer;
    }
    .vg-controls-button:hover{
        background: rgba(255, 255, 255, 0.1);
    }
    .vg-controls-button-image{
        width: 30px;
        height: 30px;
        margin: 2px;
    }
    .vg-controls-time{
        color: white;
        font-size: 16px;
        margin-left: 15px;
    }
    .vg-controls-slider{
        width: 98%;
        cursor: pointer;
        margin-left: 1%;
        margin-right: 1%;
    }
    .vg-controls-top{
        display: flex;
        align-items: center;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
</style>
    
<script>
import {mapGetters,mapMutations,mapState} from 'vuex';
import CloseIcon from 'vue-material-design-icons/Close.vue'

export default {
    components: {CloseIcon},
    data: function () {
        return {
            videoGalleryVisible: false,
            videoCurentTime: "0:00/0:00",
            paused: true,
            currentVideoIndex: 0,
            id: null,

            videos1: [
                "./flux/videos/Tread cutting.mp4","./flux/videos/Tread application.mp4","./flux/videos/SW cutting rear.mp4","./flux/videos/SW cutting front.mp4",
                "./flux/videos/Sw Application.mp4","./flux/videos/Pickup belt.mp4","./flux/videos/JLB application.mp4","./flux/videos/Il+Chafer Presetting 2.mp4",
                "./flux/videos/Il+Chafer Presetting 1.mp4","./flux/videos/Il+Chafer - Centering.mp4","./flux/videos/IL cutting.mp4","./flux/videos/Il Application.mp4",
                "./flux/videos/BP1 cutting rear.mp4","./flux/videos/BP1 cutting front.mp4","./flux/videos/Bp Application.mp4","./flux/videos/Belt B cutting.mp4",
                "./flux/videos/Belt B application.mp4","./flux/videos/Belt B - Centering.mp4","./flux/videos/Belt A application.mp4","./flux/videos/Belt A - Centering.mp4"
            ],
            videos2: [
                "./flux/videos/HF Belišće.mp4","./flux/videos/State of the art manufacturing.mp4","./flux/videos/Sustainable manufacturing.mp4"
            ]
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','localUser','localUserID','followModeratorMode','sendingFollowModerator']),
        ...mapState({session: (state) => state.session.openTokSession}), 
        getVideoURL(){
            if(this.videos)
                return this.videos[this.currentVideoIndex];
        },
        name(){
            if(this.videos)
                return this.videos[this.currentVideoIndex].split(".")[1].split("/").at(-1);
        },
        videos(){
            return this.id == 286282 ? this.videos1 : this.videos2;
        }
    },
    watch: {
        session: function(){
            if(this.session){
                this.session.on("signal:followModeratorVideoGallery", (event) => {
                    let data = event.data.split(",");
                    let userID = data[0];
                    if (userID == this.localUserID)
                        return;

                    let volume = data[1] != "undefined" ? parseFloat(data[1]) : undefined;
                    let currentVideoID = data[2] != "undefined" ? parseInt(data[2]) : undefined;
                    let paused = data[3] != "undefined" ? data[3] == "true" : undefined;
                    let fullscreen = data[4] != "undefined" ? data[4] == "true" : undefined;
                    let currentTime = data[5] != "undefined" ? parseFloat(data[5]) : undefined;
                    let id = data[6] != "undefined" ? data[6] : undefined;
                    console.log(data);
                    if(fullscreen){
                        let video =  document.getElementById("vg-video");
                        paused ? video.pause() : video.play();
                        video.currentTime = currentTime;
                        this.currentVideoIndex = currentVideoID;
                        this.id = id;
                        console.log(this.id);
                        this.videoGalleryVisible = true;
                    }else{
                        this.videoGalleryVisible = false;
                        document.getElementsByClassName("vg-video")[0].pause();
                    }

                    if(!this.videoGalleryVisible){
                        var event = new CustomEvent("changeVideoGallery",{detail:{
                            volume: volume, 
                            currentVideoID: currentVideoID, 
                            paused: paused, 
                            fullscreen: fullscreen,
                            currentTime: currentTime
                        }});
                        window.dispatchEvent(event);
                    }
                });
            }
        },
    },
	methods: {   
        ...mapMutations(['setDialogueOpen']),      
        sendModeratorCommands(e){
            if(this.session && this.sendingFollowModerator){
                const signalData = {
                    type: "followModeratorVideoGallery", 
                    data: this.localUserID + "," + e.detail.volume + "," + e.detail.currentVideoID + "," + e.detail.paused + "," + e.detail.fullscreen  + "," + e.detail.currentTime + "," + e.detail.id,
                };
                this.session.signal(signalData, function (error) {
                    if(error) console.log(['signal error (', error.code, '): ', error.message].join(''));
                    else console.log('followModeratorVideoGallery signal sent');   
                });
            }
        },
        toggleVideoGallery(){
            if(!this.canUserControllVideo()) return;

            this.videoGalleryVisible = !this.videoGalleryVisible;
            this.setDialogueOpen(this.videoGalleryVisible);
            if(!this.videoGalleryVisible){
                document.getElementsByClassName("vg-video")[0].pause();
                this.sendModeratorCommands({detail:{fullscreen: false}});
            }       
        },
        initDialogue(e){
            this.currentVideoIndex = e.detail.currentVideoIndex;
            this.id = e.detail.id;
            this.toggleVideoGallery();
        },
        playVideo(){
            if(!this.canUserControllVideo()) return;

            let video = document.getElementById("vg-video");
            video.paused ? video.play() : video.pause();
            this.sendCommands();
        },
        changeTime(){
            if(!this.canUserControllVideo()) return;

            let video = document.getElementById("vg-video");
            video.currentTime = document.getElementById("vg-slider").value;
            this.sendCommands();
        },
        skipVideo(val){
            if(!this.canUserControllVideo()) return;

            let video = document.getElementById("vg-video");
            this.currentVideoIndex += val;
            if(this.currentVideoIndex == this.videos.length)
                this.currentVideoIndex = 0;
            if(this.currentVideoIndex == -1)
                this.currentVideoIndex = this.videos.length-1;
            video.src = this.videos[this.currentVideoIndex];
            this.sendCommands();
        },
        formatTime(time) {
            var mins = Math.floor(time / 60);
            var secs = Math.floor(time - mins * 60);
            return mins + ":" + (secs < 10 ? "0" : "") + secs;
        },
        sendCommands(){
            this.sendModeratorCommands({detail:{
                volume: undefined,
                currentVideoID: this.currentVideoIndex,
                paused: document.getElementById("vg-video").paused,
                fullscreen: true,
                currentTime: document.getElementById("vg-video").currentTime,
                id: this.id
            }});

            if(!this.videoGalleryVisible){
                var event = new CustomEvent("changeVideoGallery",{detail:{
                    volume: undefined, 
                    currentVideoID: this.currentVideoIndex, 
                    paused: document.getElementById("vg-video").paused, 
                    fullscreen: undefined,
                    currentTime: document.getElementById("vg-video").currentTime
                }});
                window.dispatchEvent(event);
            }
        },
        canUserControllVideo(){
            return !this.followModeratorMode || this.sendingFollowModerator;
        }
    },
    mounted: function(){
        window.addEventListener('openVideoGallery',this.initDialogue);
        window.addEventListener('sendCommandsVideoGallery',this.sendModeratorCommands);
        
        let slider = document.getElementById("vg-slider");
        let video = document.getElementById("vg-video");
        video.onloadedmetadata = () =>{
            slider.max = video.duration;
            this.paused = video.paused;
        };
        video.ontimeupdate = () =>{
            this.videoCurentTime = this.formatTime(video.currentTime) + "/" + this.formatTime(slider.max);
            slider.value = video.currentTime;          
        };
        video.onplay = () =>{
            this.paused = false;
        }
        video.onpause = () =>{
            this.paused = true;
        }
    }
}

</script>